import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { useTheme } from '@/contexts/theme-context';

export type CircleIconSize = 'small' | 'compact' | 'medium' | 'large';

export const SIZES: Record<CircleIconSize, number> = {
  compact: 40,
  large: 64,
  medium: 48,
  small: 32,
};

const ICON_SIZES: Record<CircleIconSize, number> = {
  compact: 20,
  large: 30,
  medium: 16,
  small: 12,
};

export interface Props {
  fill?: string | null;
  Icon: React.FC<SvgProps>;
  iconHeight?: number;
  iconWidth?: number;
  size?: CircleIconSize;
  stroke?: string;
  style?: StyleProp<ViewStyle>;
}

export const CircledIcon: React.FC<Props> = ({
  fill,
  Icon,
  iconHeight,
  iconWidth,
  size = 'medium',
  stroke,
  style,
}) => {
  const theme = useTheme();

  const baseSize = SIZES[size];
  const iconSize = ICON_SIZES[size];

  return (
    <View
      style={[
        styles.base,
        {
          borderColor: theme.colors.primary,
          borderRadius: baseSize,
          height: baseSize,
          width: baseSize,
        },
        style,
      ]}
    >
      <Icon
        {...(fill !== null ? { fill: fill || theme.colors.primary } : {})}
        height={iconHeight || iconSize}
        stroke={stroke}
        width={iconWidth || iconSize}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    borderWidth: 1,
    justifyContent: 'center',
  },
});
